<template>
  <div class="zuoye">
    <div class="zuoyebg">
      <appHeader activeIndex="zuoye" ></appHeader>
      <div class="zuoyeContent">
        <!-- 介绍 -->
        <div class="zuoyeInfo">
          <div class="zuoyeInfo1">
            <img class="zuoyeInfo1Img1" src="../../assets/img/Product/zuoye.png"  alt />
            <br>
            <img class="zuoyeInfo1Img2"  src="../../assets/img/products/zuoye/zuoyeQRcode.png" alt />
            <div>扫描二维码下载</div>     
          </div>
          <div class="zuoyeInfo2">
            <img src="../../assets/img/products/zuoye/zuoyeFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>还在为作业不会做而发愁吗？还在为不知道去哪里搜答案而着急吗？《作业答案快帮》为你排忧解难！本产品包含以下功能：拍照搜题，秒出答案；作文题库，根据年级、字数和体裁，选择你需要的不同作文内容；汉字词典，搜索成语，给出解答。</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容  -->
        <el-divider></el-divider>
        <div class="zuoyeCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="zuoyeWrap">
            <div class="zuoyeMainImg" :style="{ left: nowLeft + '%' }">
              <img class="zuoyeCarouselImg"   src="../../assets/img/products/zuoye/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/zuoye.css";
</style>
